<template>
  <div class="ly-row">
    <div class="w-100">
      <data-table
        :page-size="pageSize"
        :page="page"
        :data="data"
        :columns="filteredColumns"
        :total-results="totalResults"
        :sort-options="sortOptions"
        :is-loading="isLoading"
        :enable-row-selection="enableRowSelection"
        :show-pagination="showPagination"
        :expanded-item-id="expandedItemId"
        :enable-expand-action="true"
        :row-class="rowClass"
        @on-expand="
          (expandItemId, expandedRow) =>
            emit('onExpand', expandItemId, expandedRow)
        "
        @on-sort="(_sortOptions) => $emit('onSort', _sortOptions)"
        @on-page-change="(pageNumber) => $emit('onPageChange', pageNumber)"
        @on-page-size-change="
          (_pageSize) => $emit('onPageSizeChange', _pageSize)
        "
      >
        <template v-for="col in filteredColumns" #[col.name]="{ row }">
          <slot :name="col.name" :field="row[col.name]" :row="row"></slot>
        </template>
      </data-table>
    </div>

    <ExpandedPanel
      v-if="expandedItemId"
      @on-close="emit('onExpandedItemClose')"
    >
      <template #sections>
        <slot name="data-table-panel"></slot>
      </template>
      <template #actions>
        <slot name="data-table-panel-actions"></slot>
      </template>
    </ExpandedPanel>
  </div>
</template>
<script lang="ts">
export default {
  name: 'lp-expandable-data-table',
}
</script>
<script lang="ts" setup>
import DataTable from './DataTable.vue'
import ExpandedPanel from './ExpandedPanel.vue'
import { DataTableColumn } from './types'
import { SortOptions } from './use-column-sort'
import { computed } from '@vue/reactivity'

const props = defineProps<{
  columns: DataTableColumn[]
  data: unknown[]
  page: number
  pageSize: number
  sortOptions?: SortOptions
  totalResults: number
  isLoading?: boolean
  showFixedHeader?: boolean
  rowSelection?: []
  enableRowSelection?: boolean
  showPagination?: boolean
  showResults?: boolean
  showPageSizeSelector?: boolean
  expandedItemId?: number | null
  rowClass?: string
}>()

const emit = defineEmits<{
  (event: 'onExpandedItemClose'): void
  (event: 'onSort', sortOptions: SortOptions): void
  (event: 'onPageChange', pageNumber: number): void
  (event: 'onPageSizeChange', pageSize: number): void
  (event: 'onExpand', expandItemId: number, expandRow: unknown): void
}>()
const filteredColumns = computed(() => {
  return props.columns.filter((column) => {
    if (props.expandedItemId) {
      return column.secondary !== true
    }
    return true
  })
})
</script>
